import { useEffect, useState } from "react";
import { getUserId } from "../utils/Auth";
import API_BASE_URL from "../config";

const useAgentData = () => {
  const [agentName, setAgentName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [myCustomers, setMyCustomers] = useState([]); // 🔥 Saját ügyfelek tárolása
  const userId = getUserId();
  const [canAccessMarmurist, setCanAccessMarmurist] = useState(false);

  useEffect(() => {
    const fetchAgentDetails = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await fetch(`${API_BASE_URL}/api/users/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) {
          throw new Error("Eroare la încărcarea datelor utilizatorului.");
        }

        const userData = await response.json();
        setAgentName(userData.name);
        setCanAccessMarmurist(userData.canAccessMarmurist);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchAgentDetails();
  }, [userId]);

  const fetchMyCustomers = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(`${API_BASE_URL}/api/customers`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) {
        throw new Error("Eroare la încărcarea clienților.");
      }

      const data = await response.json();
      setMyCustomers(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    agentName,
    canAccessMarmurist,
    loading,
    error,
    myCustomers,
    fetchMyCustomers, // ✅ API hívás a saját ügyfelek lekérésére
  };
};

export default useAgentData;
